import api from "../api";

export const categoriaService = {
    async loadPriorities() {
      return await api.get("/prioridades");
    },
    async loadStatusDenunciation() {
      return await api.get("/status-denuncia");
    },
  }